import { useEffect } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { enmStopFreeSaleAppType } from "../../models/enums/StopFreeSaleAppType";

export type StopFreeSaleAppTypeSelectProps = {
    onChange?: Function;
    value?: any;
    localizationTag?: string;
    mode?: "multiple" | "tags" | undefined;
    specificTypes?: enmStopFreeSaleAppType[];
}

export const StopFreeSaleAppTypeSelect = (props: StopFreeSaleAppTypeSelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    let items: { name: string; id: number }[] = (props.specificTypes ? ObjectHelper.getEnumKeyValuesForSpecificTypes(enmStopFreeSaleAppType, props.specificTypes) : ObjectHelper.enumToObjectArray(enmStopFreeSaleAppType)).map((x:any) => { return {id:x.id , name : t(`stopFreeSale.create.appType_${x.id}`)}});

    return (
        <>
            <Select
                mode={props.mode}
                size="middle"
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.choose")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={items?.map(h => Object.assign(h, {
                    label: props.localizationTag ? t(`${props.localizationTag}.${h.name.toLowerCase()}`) : h.name,
                    value: h.id
                }))}
            />
        </>
    )
}